import { readonly, ref } from 'vue'

import type { Auth0VueClient } from '@auth0/auth0-vue'
import { useAuth0 } from '@auth0/auth0-vue'

/*
 * Module-level so every caller shares one state. Auth0's logout() clears the
 * local session before it navigates, so a second call can never recover it —
 * it only re-triggers the navigation, and with it the native unsaved-changes
 * dialog. `beforeunload` handlers read this flag to stay silent during an
 * intentional logout.
 */
const loggingOut = ref<boolean>(false)

export const isLoggingOut = readonly(loggingOut)

export interface IUseLogout {
	startLogout: () => Promise<void>
}

export const useLogout = (): IUseLogout => {
	const { logout }: Auth0VueClient = useAuth0()

	const startLogout = async (): Promise<void> => {
		if (loggingOut.value) return

		loggingOut.value = true

		await logout()
	}

	return { startLogout }
}
